import React from "react";
import { showToast } from "../../../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hitGetSettingsApi } from "../../../../../Redux/Common/GetSettingsSlice";

const TermService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [text, setText] = React.useState("");
  useEffect(() => {
    if (!localStorage.getItem("clientToken")) {
      navigate("/client/login");
    } else {
      dispatch(hitGetSettingsApi()).then((response) => {
        if (response.payload && response.payload.status === true) {
          setText(response.payload.data.termsOfServiceText);
          // Handle the settings data if needed
        }
      });
    }
  }, [dispatch, navigate]);

  return (
    <>
      <div className="delete-account-container">
        <h1 className="page-title">Terms of Service</h1>

        <div className="warning-card"  dangerouslySetInnerHTML={{ __html: text }}>
        </div>
      </div>
    </>
  );
};

export default TermService;
